
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6f40"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6f40"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7BunP", function(module, exports) {

$parcel$export(module.exports, "default", () => $58938e94a0ce6c95$export$2e2bcd8739ae039);
let $58938e94a0ce6c95$var$script;




let $58938e94a0ce6c95$var$initialize = ()=>{
    $58938e94a0ce6c95$var$script = (parcelRequire("egYNt"));
    if ($58938e94a0ce6c95$var$script.__esModule) $58938e94a0ce6c95$var$script = $58938e94a0ce6c95$var$script.default;
    $58938e94a0ce6c95$var$script.render = (parcelRequire("2D3l7")).render;
    $58938e94a0ce6c95$var$script.__cssModules = {};
    (parcelRequire("bOfTr")).default($58938e94a0ce6c95$var$script);
    $58938e94a0ce6c95$var$script.__scopeId = 'data-v-21f4ba';
    $58938e94a0ce6c95$var$script.__file = "Pagination.vue";
};
$58938e94a0ce6c95$var$initialize();
var $58938e94a0ce6c95$export$2e2bcd8739ae039 = $58938e94a0ce6c95$var$script;

});
parcelRegister("egYNt", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $a641b856dbd00439$export$2e2bcd8739ae039);

var $ecd4d = parcelRequire("ecd4d");

var $jFUWD = parcelRequire("jFUWD");

var $73mM4 = parcelRequire("73mM4");

var $eHAAP = parcelRequire("eHAAP");
var $a641b856dbd00439$export$2e2bcd8739ae039 = {
    __name: 'Pagination',
    props: {
        total: {
            type: Number,
            default: 0
        },
        currentPage: {
            type: Number,
            default: 1
        },
        pageSize: {
            type: Number,
            default: 10
        },
        pageSizeOptions: {
            type: Array,
            default: ()=>[
                    10,
                    20,
                    50,
                    100
                ]
        },
        storageKey: {
            type: String,
            default: ''
        },
        showSizeSelector: {
            type: Boolean,
            default: false
        }
    },
    emits: [
        'update:currentPage',
        'update:pageSize',
        'pageChange',
        'pageSizeChange'
    ],
    setup (__props, { expose: __expose, emit: __emit }) {
        __expose();
        const { t: t, locale: locale } = (0, $jFUWD.useI18n)();
        const route = (0, $73mM4.useRoute)();
        const props = __props;
        const pageSizeOptionsMemo = (0, $ecd4d.computed)(()=>{
            return props.pageSizeOptions.map((size)=>({
                    value: size,
                    label: `${size}`
                }));
        });
        const emit = __emit;
        const paginationEl = (0, $ecd4d.ref)(null);
        const jumpPage = (0, $ecd4d.ref)(props.currentPage);
        const currentPageSize = (0, $ecd4d.ref)(props.pageSize);
        (0, $ecd4d.watch)(currentPageSize, (newSize)=>{
            if (newSize !== props.pageSize) handlePageSizeChange();
        });
        const totalPages = (0, $ecd4d.computed)(()=>{
            return Math.ceil(props.total / currentPageSize.value);
        });
        const getStorageKey = ()=>{
            if (props.storageKey) return `pagination_size_${props.storageKey}`;
            return `pagination_size_${route.name || route.path}`;
        };
        const loadPageSizeFromStorage = ()=>{
            if (!props.showSizeSelector) return;
            try {
                const storageKey = getStorageKey();
                const savedSize = localStorage.getItem(storageKey);
                if (savedSize) {
                    const size = parseInt(savedSize, 10);
                    if (props.pageSizeOptions.includes(size)) {
                        currentPageSize.value = size;
                        emit('update:pageSize', size);
                        emit('pageSizeChange', size);
                    }
                }
            } catch (error) {
                console.error('Failed to load page size from storage:', error);
            }
        };
        const savePageSizeToStorage = (size)=>{
            if (!props.showSizeSelector) return;
            try {
                const storageKey = getStorageKey();
                localStorage.setItem(storageKey, size.toString());
            } catch (error) {
                console.error('Failed to save page size to storage:', error);
            }
        };
        const handlePageSizeChange = ()=>{
            const newSize = currentPageSize.value;
            savePageSizeToStorage(newSize);
            emit('update:currentPage', 1);
            emit('update:pageSize', newSize);
            emit('pageSizeChange', newSize);
            emit('pageChange', {
                page: 1,
                pageSize: newSize
            });
        };
        (0, $ecd4d.watch)([
            ()=>props.currentPage,
            totalPages
        ], (newVal)=>{
            jumpPage.value = newVal[0];
            updatePagination();
        });
        (0, $ecd4d.watch)(()=>props.pageSize, (newSize)=>{
            currentPageSize.value = newSize;
        });
        (0, $ecd4d.watch)(locale, ()=>{
            updatePagination();
        });
        (0, $ecd4d.onMounted)(()=>{
            loadPageSizeFromStorage();
            updatePagination();
        });
        const disablePaginationItem = (className)=>{
            const item = paginationEl.value.querySelector(`.${className}`);
            if (item) {
                item.classList.add('disabled');
                const link = item.querySelector('a');
                if (link) link.style.pointerEvents = 'none';
            }
        };
        const updatePagination = ()=>{
            const { currentPage: currentPage } = props;
            console.log(t('common.page.first'));
            if (totalPages.value >= 1) {
                paginationEl.value.innerHTML = `<li class="page-item page-first"><a class="page-link" href="#">${t('common.page.first')}</a></li>
       <li class="page-item page-divider" style="color:#00365b33">|</li>
       <li class="page-item page-prev"><a class="page-link" href="#">${t('common.page.previous')}</a></li>`;
                for(let i = 1; i <= totalPages.value; i++){
                    const liEl = document.createElement('li');
                    liEl.classList.add('page-item', 'page-number');
                    if (i === Number(currentPage)) liEl.classList.add('active');
                    // add gap
                    if (i !== totalPages.value) liEl.style.marginRight = '0.5rem';
                    liEl.style.backgroundColor = '#0068B014';
                    const aEl = document.createElement('a');
                    aEl.classList.add('page-link');
                    aEl.style.color = '#0068B099';
                    aEl.href = '#';
                    aEl.textContent = i;
                    liEl.appendChild(aEl);
                    paginationEl.value.appendChild(liEl);
                }
                paginationEl.value.innerHTML += `<li class="page-item page-next"><a class="page-link" href="#">${t('common.page.next')}</a></li>
       <li class="page-item page-divider" style="color:#00365b33">|</li>
       <li class="page-item page-last"><a class="page-link" href="#">${t('common.page.last')}</a></li>`;
                if (totalPages.value === 1) {
                    const classes = [
                        'page-prev',
                        'page-next',
                        'page-first',
                        'page-last'
                    ];
                    classes.forEach((className)=>{
                        disablePaginationItem(className);
                    });
                }
                // only show 5 pages mostly
                // format page item to 1,2,...,length-1,length
                if (totalPages.value > 5) {
                    const cursor = Number(currentPage);
                    let validPages = [
                        cursor,
                        cursor + 1,
                        cursor + 2,
                        cursor + 3,
                        cursor + 4,
                        cursor + 5
                    ];
                    let centerPage = cursor + 4;
                    if (cursor > totalPages.value - 5) {
                        validPages = [
                            totalPages.value - 5,
                            totalPages.value - 4,
                            totalPages.value - 3,
                            totalPages.value - 2,
                            totalPages.value - 1,
                            totalPages.value
                        ];
                        centerPage = totalPages.value - 6;
                    }
                    const pageItems = paginationEl.value.querySelectorAll('.page-number');
                    const pageItemsArr = Array.from(pageItems);
                    pageItemsArr.forEach((item, index)=>{
                        if (!validPages.includes(index + 1)) item.style.display = 'none';
                        if (index === centerPage) {
                            item.querySelector('a').textContent = "\u2026";
                            item.querySelector('a').style.paddingLeft = '9px';
                            item.querySelector('a').style.paddingRight = '9px';
                            item.firstChild.setAttribute('disabled', '');
                            item.firstChild.style.pointerEvents = 'none';
                        }
                    });
                }
                if (currentPage === 1) {
                    disablePaginationItem('page-prev');
                    disablePaginationItem('page-first');
                }
                if (currentPage === totalPages.value) {
                    disablePaginationItem('page-next');
                    disablePaginationItem('page-last');
                }
                paginationEl.value.onclick = handlePaginationClick;
            } else paginationEl.value.innerHTML = '';
        };
        const handlePaginationClick = (e)=>{
            e.preventDefault();
            if (e.target.tagName === 'A') {
                const classes = e.target.parentElement.classList;
                let newPage = Number(e.target.textContent);
                if (classes.contains('page-first')) newPage = 1;
                if (classes.contains('page-prev')) {
                    newPage = props.currentPage - 1;
                    if (newPage < 1) newPage = 1;
                }
                if (classes.contains('page-next')) {
                    newPage = props.currentPage + 1;
                    if (newPage > totalPages.value) newPage = props.totalPages;
                }
                if (classes.contains('page-last')) newPage = totalPages.value;
                changePage(newPage);
            }
        };
        const handleJumpChange = ()=>{
            let value = Number(jumpPage.value);
            if (value > totalPages.value) {
                value = totalPages.value;
                jumpPage.value = value;
            }
            if (value < 1) {
                value = 1;
                jumpPage.value = value;
            }
            changePage(value);
        };
        const changePage = (page)=>{
            if (page !== props.currentPage) {
                emit('update:currentPage', page);
                emit('pageChange', {
                    page: page,
                    pageSize: props.pageSize
                });
            }
        };
        const __returned__ = {
            t: t,
            locale: locale,
            route: route,
            props: props,
            pageSizeOptionsMemo: pageSizeOptionsMemo,
            emit: emit,
            paginationEl: paginationEl,
            jumpPage: jumpPage,
            currentPageSize: currentPageSize,
            totalPages: totalPages,
            getStorageKey: getStorageKey,
            loadPageSizeFromStorage: loadPageSizeFromStorage,
            savePageSizeToStorage: savePageSizeToStorage,
            handlePageSizeChange: handlePageSizeChange,
            disablePaginationItem: disablePaginationItem,
            updatePagination: updatePagination,
            handlePaginationClick: handlePaginationClick,
            handleJumpChange: handleJumpChange,
            changePage: changePage,
            ref: $ecd4d.ref,
            watch: $ecd4d.watch,
            computed: $ecd4d.computed,
            onMounted: $ecd4d.onMounted,
            get useI18n () {
                return 0, $jFUWD.useI18n;
            },
            get useRoute () {
                return 0, $73mM4.useRoute;
            },
            CustomSelect: $eHAAP.default
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});

parcelRegister("2D3l7", function(module, exports) {

$parcel$export(module.exports, "render", () => $1ea1d07660c9bfe0$export$b3890eb0ae9dca99);

var $ecd4d = parcelRequire("ecd4d");
const $1ea1d07660c9bfe0$var$_hoisted_1 = {
    "aria-label": "page navigation",
    class: "pagination-wrapper"
};
const $1ea1d07660c9bfe0$var$_hoisted_2 = {
    class: "pagination-total"
};
const $1ea1d07660c9bfe0$var$_hoisted_3 = {
    ref: "paginationEl",
    class: "pagination"
};
const $1ea1d07660c9bfe0$var$_hoisted_4 = {
    class: "pagination-jump-wrapper"
};
const $1ea1d07660c9bfe0$var$_hoisted_5 = [
    "max"
];
const $1ea1d07660c9bfe0$var$_hoisted_6 = {
    key: 0,
    class: "pagination-size-selector"
};
const $1ea1d07660c9bfe0$var$_hoisted_7 = {
    class: "me-2"
};
function $1ea1d07660c9bfe0$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_i18n_t = (0, $ecd4d.resolveComponent)("i18n-t");
    return (0, $ecd4d.openBlock)(), (0, $ecd4d.createElementBlock)("nav", $1ea1d07660c9bfe0$var$_hoisted_1, [
        (0, $ecd4d.createElementVNode)("span", $1ea1d07660c9bfe0$var$_hoisted_2, (0, $ecd4d.toDisplayString)($setup.t('common.page.total', {
            detail0: $props.total
        })), 1),
        (0, $ecd4d.createElementVNode)("ul", $1ea1d07660c9bfe0$var$_hoisted_3, null, 512),
        (0, $ecd4d.createElementVNode)("div", $1ea1d07660c9bfe0$var$_hoisted_4, [
            (0, $ecd4d.createElementVNode)("label", null, [
                (0, $ecd4d.createVNode)(_component_i18n_t, {
                    keypath: "common.page.go"
                }, {
                    detail0: (0, $ecd4d.withCtx)(()=>[
                            (0, $ecd4d.withDirectives)((0, $ecd4d.createElementVNode)("input", {
                                type: "number",
                                autocomplete: "off",
                                min: "1",
                                max: $setup.totalPages,
                                step: "1",
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$setup.jumpPage = $event),
                                class: "pagination-jump",
                                style: {
                                    "width": "3rem"
                                },
                                onChange: $setup.handleJumpChange
                            }, null, 40, $1ea1d07660c9bfe0$var$_hoisted_5), [
                                [
                                    (0, $ecd4d.vModelText),
                                    $setup.jumpPage
                                ]
                            ])
                        ]),
                    _: 1
                })
            ])
        ]),
        $props.showSizeSelector ? ((0, $ecd4d.openBlock)(), (0, $ecd4d.createElementBlock)("div", $1ea1d07660c9bfe0$var$_hoisted_6, [
            (0, $ecd4d.createElementVNode)("span", $1ea1d07660c9bfe0$var$_hoisted_7, (0, $ecd4d.toDisplayString)($setup.t('file.itemsPerPage')), 1),
            (0, $ecd4d.createVNode)($setup["CustomSelect"], {
                name: "pageSize",
                modelValue: $setup.currentPageSize,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$setup.currentPageSize = $event),
                options: $setup.pageSizeOptionsMemo,
                style: {
                    "height": "28px !important",
                    "font-size": "12px",
                    "line-height": "1"
                }
            }, null, 8, [
                "modelValue",
                "options"
            ])
        ])) : (0, $ecd4d.createCommentVNode)("", true)
    ]);
}

});

parcelRegister("bOfTr", function(module, exports) {

$parcel$export(module.exports, "default", () => $8990b1443c1f27ae$export$2e2bcd8739ae039);
let $8990b1443c1f27ae$var$NOOP = ()=>{};
var $8990b1443c1f27ae$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("3GVPC", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b0227816cef5f54$export$2e2bcd8739ae039);
let $2b0227816cef5f54$var$script;




let $2b0227816cef5f54$var$initialize = ()=>{
    $2b0227816cef5f54$var$script = (parcelRequire("Fc2hW"));
    if ($2b0227816cef5f54$var$script.__esModule) $2b0227816cef5f54$var$script = $2b0227816cef5f54$var$script.default;
    $2b0227816cef5f54$var$script.render = (parcelRequire("hMhCx")).render;
    $2b0227816cef5f54$var$script.__cssModules = {};
    (parcelRequire("2Utpc")).default($2b0227816cef5f54$var$script);
    $2b0227816cef5f54$var$script.__scopeId = 'data-v-3707de';
    $2b0227816cef5f54$var$script.__file = "Table.vue";
};
$2b0227816cef5f54$var$initialize();
var $2b0227816cef5f54$export$2e2bcd8739ae039 = $2b0227816cef5f54$var$script;

});
parcelRegister("Fc2hW", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $07bd2a88005006f1$export$2e2bcd8739ae039);

var $ecd4d = parcelRequire("ecd4d");

var $h8sKa = parcelRequire("h8sKa");

var $jFUWD = parcelRequire("jFUWD");
var $07bd2a88005006f1$export$2e2bcd8739ae039 = {
    __name: 'Table',
    props: {
        data: {
            type: Array,
            default: ()=>[]
        },
        columns: {
            type: Array,
            default: ()=>[]
        },
        loading: {
            type: Boolean,
            default: false
        },
        rowHeight: {
            type: Number,
            default: 50
        },
        minWidth: {
            type: String,
            default: undefined
        },
        tableClass: {
            type: Array,
            default: ()=>[]
        },
        tableStyle: {
            type: Object,
            default: ()=>({})
        },
        theadTrStyle: {
            type: Object,
            default: ()=>({})
        },
        tbodyClass: {
            type: String,
            default: ''
        },
        tbodyTrStyle: {
            type: Object,
            default: ()=>({})
        },
        selectable: {
            type: Boolean,
            default: false
        },
        selectFixed: {
            type: Boolean,
            default: false
        },
        rowKey: {
            type: String,
            default: 'id'
        },
        defaultSelectedRowKeys: {
            type: Array,
            default: ()=>[]
        },
        disabledRows: {
            type: Array,
            default: ()=>[]
        }
    },
    emits: [
        'select',
        'select-all',
        'selection-change',
        'row-click'
    ],
    setup (__props, { expose: __expose, emit: __emit }) {
        const { locale: locale } = (0, $jFUWD.useI18n)();
        const props = __props;
        const emit = __emit;
        const tableWrapper = (0, $ecd4d.ref)(null);
        const isMobileView = (0, $ecd4d.ref)((0, $h8sKa.isMobile)());
        const selectedRowKeys = (0, $ecd4d.ref)([
            ...props.defaultSelectedRowKeys
        ]);
        const actualColumnHeaderPxWidths = (0, $ecd4d.ref)({});
        const updateActualColumnHeaderPxWidths = ()=>{
            if (!tableWrapper.value) return;
            const headerRow = tableWrapper.value.querySelector('thead > tr');
            if (!headerRow) return;
            const thElements = headerRow.children;
            const newWidths = {};
            let currentThDomIndex = 0;
            if (props.selectable) currentThDomIndex = 1;
            props.columns.forEach((column, columnIndexInProps)=>{
                const targetThElement = thElements[(props.selectable ? 1 : 0) + columnIndexInProps];
                if (targetThElement) newWidths[columnIndexInProps] = targetThElement.getBoundingClientRect().width;
            });
            actualColumnHeaderPxWidths.value = newWidths;
        };
        const computedColumnLeftPixelOffsets = (0, $ecd4d.computed)(()=>{
            const offsets = {};
            let currentCumulativeWidthPx = 0;
            if (props.selectable && props.selectFixed) {
                const selectionTh = tableWrapper.value?.querySelector('thead > tr > th.selection-column');
                if (selectionTh) currentCumulativeWidthPx = selectionTh.getBoundingClientRect().width;
            }
            props.columns.forEach((column, colIndexInProps)=>{
                if (column.fixed === 'left' || column.fixed === true) {
                    offsets[colIndexInProps] = currentCumulativeWidthPx;
                    const columnActualWidth = actualColumnHeaderPxWidths.value[colIndexInProps];
                    if (typeof columnActualWidth === 'number') currentCumulativeWidthPx += columnActualWidth;
                }
            });
            return offsets;
        });
        const getColumnLeftPosition = (colIndex)=>{
            const offset = computedColumnLeftPixelOffsets.value[colIndex];
            return typeof offset === 'number' ? `${offset}px` : undefined;
        };
        const isAllSelected = (0, $ecd4d.computed)(()=>{
            const availableRows = props.data.filter((row, index)=>!isRowDisabled(row, index));
            if (availableRows.length === 0) return false;
            return availableRows.length > 0 && availableRows.every((row, index)=>selectedRowKeys.value.includes(getRowKey(row, index)));
        });
        const isIndeterminate = (0, $ecd4d.computed)(()=>{
            const availableRows = props.data.filter((row, index)=>!isRowDisabled(row, index));
            const selectedRows = availableRows.filter((row, index)=>selectedRowKeys.value.includes(getRowKey(row, index)));
            return selectedRows.length > 0 && selectedRows.length < availableRows.length;
        });
        const getRowKey = (row, index)=>{
            return props.rowKey ? row[props.rowKey] : index;
        };
        const isRowSelected = (row, index)=>{
            const key = getRowKey(row, index);
            return selectedRowKeys.value.includes(key);
        };
        const isRowDisabled = (row, index)=>{
            const key = getRowKey(row, index);
            return props.disabledRows.includes(key);
        };
        const toggleRowSelection = (row, index)=>{
            if (isRowDisabled(row, index)) return;
            const key = getRowKey(row, index);
            const isSelected = selectedRowKeys.value.includes(key);
            if (isSelected) selectedRowKeys.value = selectedRowKeys.value.filter((k)=>k !== key);
            else selectedRowKeys.value.push(key);
            emit('select', selectedRowKeys.value, row, !isSelected);
            emit('selection-change', selectedRowKeys.value);
        };
        const toggleSelectAll = ()=>{
            if (isAllSelected.value) selectedRowKeys.value = [];
            else selectedRowKeys.value = props.data.filter((row, index)=>!isRowDisabled(row, index)).map((row, index)=>getRowKey(row, index));
            emit('select-all', selectedRowKeys.value, !isAllSelected.value);
            emit('selection-change', selectedRowKeys.value);
        };
        const onRowClick = (row, index, event)=>{
            emit('row-click', row, index, event);
        };
        const lastLeftFixedIndex = (0, $ecd4d.computed)(()=>{
            let lastIndex = -1;
            props.columns.forEach((column, index)=>{
                if (column.fixed === 'left' || column.fixed === true) lastIndex = index;
            });
            return lastIndex;
        });
        const firstRightFixedIndex = (0, $ecd4d.computed)(()=>{
            for(let i = 0; i < props.columns.length; i++){
                if (props.columns[i].fixed === 'right') return i;
            }
            return -1;
        });
        const isLastLeftFixedColumn = (index)=>{
            return index === lastLeftFixedIndex.value;
        };
        const isFirstRightFixedColumn = (index)=>{
            return index === firstRightFixedIndex.value;
        };
        const getValueByPath = (object, path)=>{
            if (!path) return object;
            const column = props.columns.find((col)=>col.prop === path);
            if (column && typeof column.formatter === 'function') return column.formatter(object);
            return object[path] ?? "\u2014";
        };
        const checkTableScroll = ()=>{
            const _table = tableWrapper.value?.querySelector('.scanat-table');
            const _wrapper = tableWrapper.value;
            if (_wrapper?.scrollWidth > _wrapper?.offsetWidth) _table?.classList?.add('has-scroll');
            else _table?.classList?.remove('has-scroll');
        };
        const initTooltips = ()=>{
            checkTableScroll();
            const root = tableWrapper.value || document;
            const tooltips = root.querySelectorAll('[data-mdb-tooltip-init]');
            tooltips.forEach((tooltip)=>{
                const isTextTruncated = tooltip.scrollWidth > tooltip.clientWidth;
                const currentText = (tooltip.innerText || '').trim();
                const tooltipInstance = mdb?.Tooltip?.getInstance(tooltip);
                if (!isTextTruncated) {
                    tooltipInstance?.dispose();
                    tooltip.removeAttribute('title');
                    tooltip.removeAttribute('data-mdb-original-title');
                } else {
                    if (tooltip.getAttribute('title') !== currentText) {
                        tooltip.setAttribute('title', currentText);
                        tooltip.setAttribute('data-mdb-original-title', currentText);
                    }
                    // Recreate instance to ensure new content is used
                    if (tooltipInstance) tooltipInstance.dispose();
                    if (mdb?.Tooltip) new mdb.Tooltip(tooltip, {
                        container: 'body'
                    });
                }
            });
        };
        __expose({
            getSelectedRowKeys: ()=>selectedRowKeys.value,
            getSelectedRows: ()=>props.data.filter((row, index)=>selectedRowKeys.value.includes(getRowKey(row, index))),
            setSelectedRowKeys: (keys)=>{
                selectedRowKeys.value = keys;
                emit('selection-change', selectedRowKeys.value);
            },
            clearSelection: ()=>{
                selectedRowKeys.value = [];
                emit('selection-change', selectedRowKeys.value);
            }
        });
        (0, $ecd4d.watch)(()=>props.data, ()=>{
            console.log('watch');
            requestAnimationFrame(()=>{
                const tooltips = document.querySelectorAll('[data-mdb-tooltip-init]');
                const observer = new ResizeObserver((entries)=>{
                    initTooltips();
                });
                tooltips.forEach((e)=>{
                    observer.observe(e);
                });
                (0, $ecd4d.nextTick)(()=>{
                    updateActualColumnHeaderPxWidths();
                });
            });
        });
        (0, $ecd4d.watch)(()=>props.defaultSelectedRowKeys, (newKeys)=>{
            selectedRowKeys.value = [
                ...newKeys
            ];
        }, {
            deep: true
        });
        (0, $ecd4d.watch)(selectedRowKeys, (newSelection)=>{});
        (0, $ecd4d.watch)(()=>props.columns, ()=>{
            (0, $ecd4d.nextTick)(()=>{
                updateActualColumnHeaderPxWidths();
            });
        }, {
            deep: true
        });
        (0, $ecd4d.watch)([
            ()=>props.selectable,
            ()=>props.selectFixed
        ], ()=>{
            (0, $ecd4d.nextTick)(()=>{
                updateActualColumnHeaderPxWidths();
            });
        });
        const handleScroll = ()=>{
            if (tableWrapper.value) {
                tableWrapper.value.addEventListener('scroll', handleScroll);
                handleScroll();
            }
        };
        const handleResize = ()=>{
            isMobileView.value = (0, $h8sKa.isMobile)();
        };
        (0, $ecd4d.onMounted)(()=>{
            initTooltips();
            window.addEventListener('resize', initTooltips);
            window.addEventListener('resize', handleResize);
            // New logic for actual column widths
            (0, $ecd4d.nextTick)(()=>{
                updateActualColumnHeaderPxWidths();
            });
            window.addEventListener('resize', updateActualColumnHeaderPxWidths);
        });
        (0, $ecd4d.onUnmounted)(()=>{
            window.removeEventListener('resize', initTooltips);
            window.removeEventListener('resize', handleResize);
            window.removeEventListener('resize', updateActualColumnHeaderPxWidths); // Cleanup listener
        });
        const __returned__ = {
            locale: locale,
            props: props,
            emit: emit,
            tableWrapper: tableWrapper,
            isMobileView: isMobileView,
            selectedRowKeys: selectedRowKeys,
            actualColumnHeaderPxWidths: actualColumnHeaderPxWidths,
            updateActualColumnHeaderPxWidths: updateActualColumnHeaderPxWidths,
            computedColumnLeftPixelOffsets: computedColumnLeftPixelOffsets,
            getColumnLeftPosition: getColumnLeftPosition,
            isAllSelected: isAllSelected,
            isIndeterminate: isIndeterminate,
            getRowKey: getRowKey,
            isRowSelected: isRowSelected,
            isRowDisabled: isRowDisabled,
            toggleRowSelection: toggleRowSelection,
            toggleSelectAll: toggleSelectAll,
            onRowClick: onRowClick,
            lastLeftFixedIndex: lastLeftFixedIndex,
            firstRightFixedIndex: firstRightFixedIndex,
            isLastLeftFixedColumn: isLastLeftFixedColumn,
            isFirstRightFixedColumn: isFirstRightFixedColumn,
            getValueByPath: getValueByPath,
            checkTableScroll: checkTableScroll,
            initTooltips: initTooltips,
            handleScroll: handleScroll,
            handleResize: handleResize,
            ref: $ecd4d.ref,
            onMounted: $ecd4d.onMounted,
            onUnmounted: $ecd4d.onUnmounted,
            computed: $ecd4d.computed,
            watch: $ecd4d.watch,
            nextTick: $ecd4d.nextTick,
            get isMobile () {
                return 0, $h8sKa.isMobile;
            },
            get useI18n () {
                return 0, $jFUWD.useI18n;
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});

parcelRegister("hMhCx", function(module, exports) {

$parcel$export(module.exports, "render", () => $cf14966b036c7180$export$b3890eb0ae9dca99);

var $ecd4d = parcelRequire("ecd4d");
const $cf14966b036c7180$var$_hoisted_1 = {
    class: "position-relative w-auto"
};
const $cf14966b036c7180$var$_hoisted_2 = {
    style: {
        "overflow": "auto",
        "background-color": "#fff",
        "max-height": "600px",
        "margin-top": "1rem"
    },
    ref: "tableWrapper"
};
const $cf14966b036c7180$var$_hoisted_3 = {
    style: {
        "position": "sticky",
        "top": "0",
        "z-index": "12"
    }
};
const $cf14966b036c7180$var$_hoisted_4 = {
    class: "form-check"
};
const $cf14966b036c7180$var$_hoisted_5 = [
    "checked",
    "indeterminate"
];
const $cf14966b036c7180$var$_hoisted_6 = {
    key: 0,
    class: "lock-shadow-left"
};
const $cf14966b036c7180$var$_hoisted_7 = {
    key: 0
};
const $cf14966b036c7180$var$_hoisted_8 = {
    key: 1
};
const $cf14966b036c7180$var$_hoisted_9 = {
    key: 2,
    class: "lock-shadow-left"
};
const $cf14966b036c7180$var$_hoisted_10 = {
    key: 3,
    class: "lock-shadow-right"
};
const $cf14966b036c7180$var$_hoisted_11 = [
    "onClick"
];
const $cf14966b036c7180$var$_hoisted_12 = {
    class: "form-check"
};
const $cf14966b036c7180$var$_hoisted_13 = [
    "checked",
    "disabled",
    "onChange"
];
const $cf14966b036c7180$var$_hoisted_14 = {
    key: 0,
    class: "lock-shadow-left"
};
const $cf14966b036c7180$var$_hoisted_15 = {
    key: 0,
    class: "text-ellipsis"
};
const $cf14966b036c7180$var$_hoisted_16 = {
    "data-mdb-tooltip-init": "",
    "data-mdb-placement": "top",
    "data-mdb-custom-class": "tooltip-name"
};
const $cf14966b036c7180$var$_hoisted_17 = {
    key: 2,
    class: "lock-shadow-left"
};
const $cf14966b036c7180$var$_hoisted_18 = {
    key: 3,
    class: "lock-shadow-right"
};
const $cf14966b036c7180$var$_hoisted_19 = {
    key: 0,
    class: "table-spinner w-100 h-100 position-absolute top-0 left-0 d-flex justify-content-center align-items-center",
    style: {
        "z-index": "1200",
        "background-color": "rgba(255, 255, 255, 0.6)"
    }
};
function $cf14966b036c7180$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ecd4d.openBlock)(), (0, $ecd4d.createElementBlock)("div", $cf14966b036c7180$var$_hoisted_1, [
        (0, $ecd4d.createElementVNode)("div", $cf14966b036c7180$var$_hoisted_2, [
            (0, $ecd4d.createElementVNode)("table", {
                class: (0, $ecd4d.normalizeClass)([
                    'table',
                    'scanat-table',
                    'align-middle',
                    ...$props.tableClass
                ]),
                style: (0, $ecd4d.normalizeStyle)({
                    tableLayout: 'auto',
                    color: '#16191e',
                    fontSize: '0.875rem',
                    minWidth: $props.minWidth,
                    borderCollapse: 'separate',
                    borderSpacing: '0',
                    ...$props.tableStyle
                })
            }, [
                (0, $ecd4d.createElementVNode)("thead", $cf14966b036c7180$var$_hoisted_3, [
                    (0, $ecd4d.createElementVNode)("tr", {
                        style: (0, $ecd4d.normalizeStyle)({
                            ...$props.theadTrStyle
                        })
                    }, [
                        $props.selectable ? ((0, $ecd4d.openBlock)(), (0, $ecd4d.createElementBlock)("th", {
                            key: 0,
                            class: (0, $ecd4d.normalizeClass)([
                                "selection-column",
                                {
                                    'lock-left': $props.selectFixed && !$setup.isMobileView
                                }
                            ]),
                            style: (0, $ecd4d.normalizeStyle)({
                                zIndex: $setup.isMobileView ? 'auto' : 3,
                                left: $props.selectFixed && !$setup.isMobileView ? '0px' : 'auto'
                            })
                        }, [
                            (0, $ecd4d.createElementVNode)("div", $cf14966b036c7180$var$_hoisted_4, [
                                (0, $ecd4d.createElementVNode)("input", {
                                    type: "checkbox",
                                    class: "form-check-input",
                                    checked: $setup.isAllSelected,
                                    indeterminate: $setup.isIndeterminate,
                                    onChange: $setup.toggleSelectAll
                                }, null, 40, $cf14966b036c7180$var$_hoisted_5)
                            ]),
                            !$setup.isMobileView && $setup.isLastLeftFixedColumn(-1) ? ((0, $ecd4d.openBlock)(), (0, $ecd4d.createElementBlock)("div", $cf14966b036c7180$var$_hoisted_6)) : (0, $ecd4d.createCommentVNode)("", true)
                        ], 6)) : (0, $ecd4d.createCommentVNode)("", true),
                        ((0, $ecd4d.openBlock)(true), (0, $ecd4d.createElementBlock)((0, $ecd4d.Fragment), null, (0, $ecd4d.renderList)($props.columns, (column, index)=>{
                            return (0, $ecd4d.openBlock)(), (0, $ecd4d.createElementBlock)("th", {
                                key: index,
                                scope: "col",
                                class: (0, $ecd4d.normalizeClass)([
                                    (column.fixed === 'left' || column.fixed === true) && !$setup.isMobileView ? 'lock-left' : '',
                                    column.fixed === 'right' && !$setup.isMobileView ? 'lock-right' : '',
                                    column.class
                                ]),
                                style: (0, $ecd4d.normalizeStyle)({
                                    left: (column.fixed === 'left' || column.fixed === true) && !$setup.isMobileView ? $setup.getColumnLeftPosition(index) : undefined,
                                    right: column.fixed === 'right' && !$setup.isMobileView ? `${column.right || 0}px` : undefined,
                                    maxWidth: column.maxWidth,
                                    width: column.width,
                                    minWidth: column.minWidth,
                                    zIndex: !$setup.isMobileView && ((column.fixed === 'left' || column.fixed === true) && index === 0 || column.fixed === 'right' && index === $props.columns.length - 1) ? 3 : undefined,
                                    ...column.style
                                })
                            }, [
                                column.customHeader ? ((0, $ecd4d.openBlock)(), (0, $ecd4d.createElementBlock)("div", $cf14966b036c7180$var$_hoisted_7, [
                                    (0, $ecd4d.renderSlot)(_ctx.$slots, `header-${column.prop}`, {
                                        key: `custom-header-${$setup.locale}`,
                                        row: column,
                                        column: column,
                                        index: index
                                    })
                                ])) : ((0, $ecd4d.openBlock)(), (0, $ecd4d.createElementBlock)("span", $cf14966b036c7180$var$_hoisted_8, (0, $ecd4d.toDisplayString)(column.title), 1)),
                                !$setup.isMobileView && $setup.isLastLeftFixedColumn(index) ? ((0, $ecd4d.openBlock)(), (0, $ecd4d.createElementBlock)("div", $cf14966b036c7180$var$_hoisted_9)) : (0, $ecd4d.createCommentVNode)("", true),
                                !$setup.isMobileView && $setup.isFirstRightFixedColumn(index) ? ((0, $ecd4d.openBlock)(), (0, $ecd4d.createElementBlock)("div", $cf14966b036c7180$var$_hoisted_10)) : (0, $ecd4d.createCommentVNode)("", true)
                            ], 6);
                        }), 128))
                    ], 4)
                ]),
                (0, $ecd4d.createElementVNode)("tbody", {
                    style: {
                        maxHeight: '20rem'
                    },
                    class: (0, $ecd4d.normalizeClass)($props.tbodyClass)
                }, [
                    $props.data && $props.data.length ? ((0, $ecd4d.openBlock)(true), (0, $ecd4d.createElementBlock)((0, $ecd4d.Fragment), {
                        key: 0
                    }, (0, $ecd4d.renderList)($props.data, (row, rowIndex)=>{
                        return (0, $ecd4d.openBlock)(), (0, $ecd4d.createElementBlock)("tr", {
                            key: rowIndex,
                            style: (0, $ecd4d.normalizeStyle)({
                                height: $props.rowHeight + 'px',
                                ...$props.tbodyTrStyle
                            }),
                            class: (0, $ecd4d.normalizeClass)({
                                'row-selected': $setup.selectedRowKeys.includes($setup.getRowKey(row, rowIndex))
                            }),
                            onClick: ($event)=>$setup.onRowClick(row, rowIndex, $event)
                        }, [
                            $props.selectable ? ((0, $ecd4d.openBlock)(), (0, $ecd4d.createElementBlock)("td", {
                                key: 0,
                                class: (0, $ecd4d.normalizeClass)([
                                    "selection-column",
                                    {
                                        'lock-left': $props.selectFixed && !$setup.isMobileView
                                    }
                                ]),
                                style: (0, $ecd4d.normalizeStyle)({
                                    zIndex: $setup.isMobileView ? 'auto' : 3,
                                    left: $props.selectFixed && !$setup.isMobileView ? '0px' : 'auto'
                                })
                            }, [
                                (0, $ecd4d.createElementVNode)("div", $cf14966b036c7180$var$_hoisted_12, [
                                    (0, $ecd4d.createElementVNode)("input", {
                                        type: "checkbox",
                                        class: "form-check-input",
                                        checked: $setup.isRowSelected(row, rowIndex),
                                        disabled: $setup.isRowDisabled(row, rowIndex),
                                        onClick: _cache[0] || (_cache[0] = (0, $ecd4d.withModifiers)(()=>{}, [
                                            "stop"
                                        ])),
                                        onChange: ($event)=>$setup.toggleRowSelection(row, rowIndex)
                                    }, null, 40, $cf14966b036c7180$var$_hoisted_13)
                                ]),
                                !$setup.isMobileView && $setup.isLastLeftFixedColumn(-1) ? ((0, $ecd4d.openBlock)(), (0, $ecd4d.createElementBlock)("div", $cf14966b036c7180$var$_hoisted_14)) : (0, $ecd4d.createCommentVNode)("", true)
                            ], 6)) : (0, $ecd4d.createCommentVNode)("", true),
                            ((0, $ecd4d.openBlock)(true), (0, $ecd4d.createElementBlock)((0, $ecd4d.Fragment), null, (0, $ecd4d.renderList)($props.columns, (column, colIndex)=>{
                                return (0, $ecd4d.openBlock)(), (0, $ecd4d.createElementBlock)("td", {
                                    key: colIndex,
                                    class: (0, $ecd4d.normalizeClass)([
                                        (column.fixed === 'left' || column.fixed === true) && !$setup.isMobileView ? 'lock-left' : '',
                                        column.fixed === 'right' && !$setup.isMobileView ? 'lock-right' : '',
                                        column.dataClass
                                    ]),
                                    style: (0, $ecd4d.normalizeStyle)({
                                        left: (column.fixed === 'left' || column.fixed === true) && !$setup.isMobileView ? $setup.getColumnLeftPosition(colIndex) : undefined,
                                        right: column.fixed === 'right' && !$setup.isMobileView ? `${column.right || 0}px` : undefined,
                                        maxWidth: column.maxWidth,
                                        width: column.width,
                                        minWidth: column.width,
                                        zIndex: !$setup.isMobileView && ((column.fixed === 'left' || column.fixed === true) && colIndex === 0 || column.fixed === 'right' && colIndex === $props.columns.length - 1) ? 3 : undefined,
                                        ...column.dataStyle
                                    })
                                }, [
                                    column.prop === 'actions' ? ((0, $ecd4d.openBlock)(), (0, $ecd4d.createElementBlock)("div", $cf14966b036c7180$var$_hoisted_15, [
                                        (0, $ecd4d.createElementVNode)("span", null, [
                                            (0, $ecd4d.renderSlot)(_ctx.$slots, "cell-actions", {
                                                row: row,
                                                column: column,
                                                index: rowIndex
                                            }, ()=>[
                                                    (0, $ecd4d.createTextVNode)((0, $ecd4d.toDisplayString)($setup.getValueByPath(row, column.prop)), 1)
                                                ])
                                        ])
                                    ])) : ((0, $ecd4d.openBlock)(), (0, $ecd4d.createElementBlock)("div", {
                                        key: 1,
                                        class: (0, $ecd4d.normalizeClass)(column.noEllipsis ? '' : 'text-ellipsis')
                                    }, [
                                        (0, $ecd4d.createElementVNode)("span", $cf14966b036c7180$var$_hoisted_16, [
                                            (0, $ecd4d.renderSlot)(_ctx.$slots, `cell-${column.prop}`, {
                                                row: row,
                                                column: column,
                                                index: rowIndex
                                            }, ()=>[
                                                    (0, $ecd4d.createTextVNode)((0, $ecd4d.toDisplayString)($setup.getValueByPath(row, column.prop)), 1)
                                                ])
                                        ])
                                    ], 2)),
                                    !$setup.isMobileView && $setup.isLastLeftFixedColumn(colIndex) ? ((0, $ecd4d.openBlock)(), (0, $ecd4d.createElementBlock)("div", $cf14966b036c7180$var$_hoisted_17)) : (0, $ecd4d.createCommentVNode)("", true),
                                    !$setup.isMobileView && $setup.isFirstRightFixedColumn(colIndex) ? ((0, $ecd4d.openBlock)(), (0, $ecd4d.createElementBlock)("div", $cf14966b036c7180$var$_hoisted_18)) : (0, $ecd4d.createCommentVNode)("", true)
                                ], 6);
                            }), 128))
                        ], 14, $cf14966b036c7180$var$_hoisted_11);
                    }), 128)) : (0, $ecd4d.createCommentVNode)("", true)
                ], 2)
            ], 6)
        ], 512),
        $props.loading ? ((0, $ecd4d.openBlock)(), (0, $ecd4d.createElementBlock)("div", $cf14966b036c7180$var$_hoisted_19, [
            ..._cache[1] || (_cache[1] = [
                (0, $ecd4d.createElementVNode)("div", {
                    class: "spinner-border text-primary",
                    role: "status"
                }, [
                    (0, $ecd4d.createElementVNode)("span", {
                        class: "visually-hidden"
                    }, "Loading...")
                ], -1)
            ])
        ])) : (0, $ecd4d.createCommentVNode)("", true)
    ]);
}

});

parcelRegister("2Utpc", function(module, exports) {

$parcel$export(module.exports, "default", () => $21e79f100677d983$export$2e2bcd8739ae039);
let $21e79f100677d983$var$NOOP = ()=>{};
var $21e79f100677d983$export$2e2bcd8739ae039 = (script)=>{};

});



//# sourceMappingURL=Dashboard.76b0dda9.js.map
